import { render, staticRenderFns } from "./StaticPageEditor.vue?vue&type=template&id=de8042e4&scoped=true&"
import script from "./StaticPageEditor.vue?vue&type=script&lang=js&"
export * from "./StaticPageEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8042e4",
  null
  
)

export default component.exports